module.exports = __webpack_public_path__ + "static/media/eye.a62db080.svg";